
import TransactionList from '@/components/TransactionList.vue'
import ContractBox from './ContractBox.vue'
import { useApi } from '@/lib/api'
import { formatDate } from '@/lib/filters'
import { computed, defineComponent, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useAppViewedList } from '@/lib/common'

export default defineComponent({
  components: { TransactionList, ContractBox },
  setup() {
    const { setRecord } = useAppViewedList()
    const _api = useApi()
    const _route = useRoute()
    const data = ref({ contract: { client: {}, dateFrom: null, dateTo: null, transactionList: [] } })

    const getData = async () => {
      const res = await _api.get<any>('report?id=' + _route.params.id)
      if (res.status === 200) {
        const r = admin.value ? 'adminReportList' : 'reportList'
        setRecord(r + res.data.id)
        data.value = res.data
      }
    }

    const admin = computed(() => _route.fullPath.indexOf('/administracija') === 0)

    getData()

    return { data, formatDate, admin }
  }
})
